function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import PromiseResolver from "./promise-resolver"; // set your parent should to position: relative unless you want a full screen loader

var PromiseResolverLoading = function PromiseResolverLoading(_ref) {
  var render = _ref.render,
      children = _ref.children,
      LoadingComponent = _ref.LoadingComponent,
      props = _objectWithoutProperties(_ref, ["render", "children", "LoadingComponent"]);

  var cb = typeof render === "function" ? render : children;
  return React.createElement(PromiseResolver, _extends({
    children: function children(args) {
      return args.loading ? React.createElement("div", {
        style: {
          textAlign: "center",
          position: "absolute",
          top: "50%",
          left: "50%"
        }
      }, LoadingComponent) : cb(args);
    }
  }, props));
};

PromiseResolverLoading.propTypes = {
  render: PropTypes.func,
  LoadingComponent: PropTypes.element
};
PromiseResolverLoading.default = {
  render: function render() {
    return null;
  },
  LoadingComponent: React.createElement("div", null, "Loading...")
};
export default PromiseResolverLoading;